/* ===========================================================
   HP Card Video v6 — זיהוי ללא תלות בשמות מחלקות
   פנינה לבית / glasspics-homepearl.com

   התקנה:
   1. Assets → product-card-video.js
   2. layout/theme.liquid לפני </head>:
      <script src="{{ 'product-card-video.js' | asset_url }}" defer="defer"></script>

   מאתר קישורי מוצר עם תמונה, בודק ב-/products/<handle>.js אם יש וידאו,
   ומזריק שכבת ניגון + כפתור רק למי שיש.

   שינויים ב-v6:
   - נוסף: זיהוי סרטוני Cloudflare R2 (המנגנון החדש) דרך הסימון
     <!-- hpvideo:URL --> שנכתב בתיאור המוצר. אלה מתנגנים בריחוף
     בדיוק כמו סרטון ממדיה נטיבית - קובץ MP4 ישיר, בלי צורך בשום
     נפילה חזרה ל-iframe. נבדק לפני ה-Drive iframe הישן (עדיפות ל-R2).
   - נוסף: openProductVideo() כעת יודע לגלול/להפעיל גם סרטון R2 בעמוד
     המוצר עצמו (זיהוי לפי data-hp-video על תגית ה-<video>).

   שינויים ב-v5:
   - תוקן: מוצרים שהסרטון שלהם מזוהה דרך התיאור (iframe של Google Drive)
     קיבלו כפתור פליי אבל לא ניגנו בריחוף — עכשיו הם מנגנים.
     המנגנון: חילוץ File ID מכתובת ה-embed ובניית src ישיר ל-<video>,
     ואם הדפדפן לא מצליח לנגן אותו — נפילה חזרה ל-iframe בריחוף.
   - נוסף: attachHoverFrame() — ריחוף מבוסס iframe, אותה התנהגות
     (opacity 0→1, טעינה עצלה, ניקוי ביציאה) רק בלי scrub ובלי פס התקדמות.

   שינויים ב-v4:
   - תוקן: הכניסה לעמוד המוצר פתחה את הלייטבוקס של Dawn (כל המדיה, בלי חזרה)
     במקום לנגן את הסרטון בגלריה.
   - תוקן: קליק על התמונה הממוזערת לא עבד (נלחץ <li> במקום ה-<button> שבתוכו).
   - נוסף: הפעלה מפורשת של הסרטון עם נפילה חזרה למצב מושתק.
   - נוסף: ניקוי הפרמטר מה-URL אחרי הפעלה.
   =========================================================== */

(function () {
  'use strict';

  var CFG = {
    SCRUB: false,
    DEBUG: false,             /* לשנות ל-true רק לצורך אבחון */
    GOLD: '#b8922e',
    LABEL: 'צפו באיכות ההדפסה',
    SIDE: 'start',
    PRELOAD_MARGIN: '400px',
    MAX_CLIMB: 6,             /* כמה רמות לטפס מהקישור בחיפוש תמונה */
    FRAME_ZOOM: 1.85          /* הגדלת ה-iframe של Drive כדי לחתוך פסים שחורים + ממשק הנגן */
  };

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var done = {};

  function log() {
    if (CFG.DEBUG) console.log.apply(console, ['[hp-cv]'].concat([].slice.call(arguments)));
  }

  /* ========== CSS ========== */
  function injectCSS() {
    if (document.getElementById('hp-cv-styles')) return;
    var side = CFG.SIDE === 'end' ? 'inset-inline-end' : 'inset-inline-start';
    var s = document.createElement('style');
    s.id = 'hp-cv-styles';
    s.textContent = [
      '.hp-cv{position:absolute;inset:0;pointer-events:none;z-index:20;overflow:hidden}',
      '.hp-cv__video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;opacity:0;transition:opacity .35s ease}',
      '.hp-cv.is-playing .hp-cv__video{opacity:1}',
      /* מסלול ה-iframe (סרטון מזוהה דרך התיאור) — אותה התנהגות ויזואלית כמו <video>.
         ה-iframe מוגדל ומרוכז בתוך מיכל עם overflow:hidden — כך נחתכים גם הפסים
         השחורים של הנגן, גם אייקון "פתח בחלון חדש" בפינה, וגם סרגל ההתקדמות התחתון. */
      '.hp-cv__frame-clip{position:absolute;inset:0;overflow:hidden;opacity:0;pointer-events:none;transition:opacity .35s ease}',
      '.hp-cv.is-playing .hp-cv__frame-clip{opacity:1}',
      '.hp-cv__frame{position:absolute;top:50%;left:50%;width:100%;height:100%;border:0;pointer-events:none;transform:translate(-50%,-50%) scale(' + CFG.FRAME_ZOOM + ');transform-origin:center center}',
      '.hp-cv__progress{position:absolute;bottom:0;inset-inline-start:0;height:3px;width:0;background:' + CFG.GOLD + ';opacity:0;transition:opacity .2s ease}',
      '.hp-cv.is-playing .hp-cv__progress{opacity:1}',
      '.hp-cv__btn{position:absolute;bottom:12px;' + side + ':12px;display:inline-flex;align-items:center;gap:6px;height:34px;padding:0 10px;border-radius:999px;background:rgba(255,255,255,.94);color:#2c2418;text-decoration:none;font-size:12px;line-height:1;pointer-events:auto;transition:background .2s,transform .2s}',
      '.hp-cv__btn:hover,.hp-cv__btn:focus-visible{background:#fff;transform:translateY(-1px)}',
      '.hp-cv__btn:focus-visible{outline:2px solid ' + CFG.GOLD + ';outline-offset:2px}',
      '.hp-cv__icon{width:15px;height:15px;flex:0 0 auto;position:relative;z-index:1}',
      '.hp-cv__label{max-width:0;overflow:hidden;white-space:nowrap;opacity:0;transition:max-width .3s,opacity .25s;position:relative;z-index:1}',
      '.hp-cv-host:hover .hp-cv__label,.hp-cv__btn:hover .hp-cv__label,.hp-cv__btn:focus-visible .hp-cv__label{max-width:170px;opacity:1}',
      '.hp-cv__pulse{position:absolute;bottom:0;' + side + ':0;width:34px;height:34px;border-radius:999px;background:' + CFG.GOLD + '8c;animation:hp-cv-pulse 2.4s cubic-bezier(.25,.8,.35,1) infinite;z-index:0}',
      '@keyframes hp-cv-pulse{0%{transform:scale(1);opacity:.55}70%{transform:scale(1.9);opacity:0}100%{transform:scale(1.9);opacity:0}}',
      '@media (hover:none),(pointer:coarse){.hp-cv__video,.hp-cv__frame-clip{display:none}.hp-cv__label{max-width:170px;opacity:1}}',
      '@media (prefers-reduced-motion:reduce){.hp-cv__pulse{animation:none;opacity:0}}',
      /* בזמן מעבר לסרטון בעמוד המוצר — לבטל את אנימציית ההופעה של Dawn כדי שהסלייד לא יישאר שקוף */
      '.hp-cv-target.scroll-trigger--offscreen{opacity:1!important;transform:none!important}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ========== נתוני מוצר ========== */
  function getProduct(handle) {
    var key = 'hpcv:' + handle;
    try {
      var c = sessionStorage.getItem(key);
      if (c) return Promise.resolve(JSON.parse(c));
    } catch (e) {}

    return fetch(ROOT.replace(/\/$/, '') + '/products/' + handle + '.js')
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (d) {
        var slim = { url: d.url, video: null };

        /* מזהה 1 — דרך המדיה של המוצר */
        (d.media || []).forEach(function (m) {
          if (slim.video) return;
          if (m.media_type === 'video' || m.media_type === 'external_video') {
            var mp4 = null;
            (m.sources || []).forEach(function (s) { if (s.format === 'mp4') mp4 = s.url; });
            slim.video = { id: m.id, src: mp4 };
          }
        });

        /* מזהה 2 — דרך התיאור, סרטון Cloudflare R2 (המנגנון החדש).
           מחפשים את הסימון <!-- hpvideo:URL --> שה-workflow כותב בתיאור
           מיד ליד תגית ה-<video>. קובץ MP4 ישיר לגמרי - בלי שום נפילה
           חזרה ל-iframe נדרשת, מתנגן בריחוף באיכות מלאה בדיוק כמו מדיה נטיבית. */
        if (!slim.video) {
          try {
            var mR2 = String(d.description || '').match(/<!--\s*hpvideo:(\S+?)\s*-->/i);
            if (mR2 && mR2[1]) {
              slim.video = { id: 'r2', src: mR2[1] };
            }
          } catch (e) {}
        }

        /* מזהה 3 — דרך התיאור (iframe של Google Drive, המנגנון הישן/fallback).
           מחלצים File ID ובונים src ישיר כדי שיהיה מה לתת ל-<video>,
           ושומרים את כתובת ה-embed כנפילה חזרה. */
        if (!slim.video) {
          try {
            var m2 = String(d.description || '').match(/<iframe[^>]+src=["']([^"']*drive\.google\.com[^"']*)["'][^>]*>/i);
            if (m2 && m2[1]) {
              var embed = m2[1];
              var fid = embed.match(/\/d\/([^/?&#]+)/) || embed.match(/[?&]id=([^&#]+)/);
              slim.video = {
                id: 'desc',
                src: fid ? 'https://drive.google.com/uc?export=download&id=' + fid[1] : null,
                embedSrc: embed
              };
            }
          } catch (e) {}
        }

        try { sessionStorage.setItem(key, JSON.stringify(slim)); } catch (e) {}
        return slim;
      });
  }

  /* ========== מציאת מיכל התמונה ========== */
  function findBox(link) {
    var img = link.querySelector('img');
    var node = link;
    var climbs = 0;

    while (!img && node && climbs < CFG.MAX_CLIMB) {
      node = node.parentElement;
      climbs++;
      if (node) img = node.querySelector('img');
    }
    if (!img) return null;

    var box = img.parentElement;
    while (box && (box.tagName === 'PICTURE' || box.tagName === 'SOURCE')) box = box.parentElement;
    if (!box) return null;

    /* אם המיכל קטן מדי ביחס לתמונה, עולים רמה */
    if (box.clientHeight && img.clientHeight && box.clientHeight < img.clientHeight * 0.6) {
      box = box.parentElement || box;
    }
    return box;
  }

  /* ========== בניית השכבה ========== */
  function buildLayer(box, product, title) {
    var v = product.video;
    if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
    box.classList.add('hp-cv-host');

    var wrap = document.createElement('div');
    wrap.className = 'hp-cv';

    var html = '';
    if (v.src) {
      html += '<video class="hp-cv__video" muted loop playsinline preload="none" tabindex="-1" aria-hidden="true"></video>' +
              '<span class="hp-cv__progress" aria-hidden="true"></span>';
    }
    /* ללא #hp-video — ההאש גרם לקפיצת גלילה מיותרת ולעמוד ריק בנייד */
    html += '<a class="hp-cv__btn" href="' + (product.url || '') + '?hpmedia=' + v.id + '"' +
            ' aria-label="צפייה בסרטון איכות ההדפסה של ' + String(title || 'המוצר').replace(/["<>]/g, '') + '">' +
            '<span class="hp-cv__pulse" aria-hidden="true"></span>' +
            '<svg class="hp-cv__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 5.5v13l11-6.5-11-6.5z" fill="currentColor"/></svg>' +
            '<span class="hp-cv__label">' + CFG.LABEL + '</span></a>';

    wrap.innerHTML = html;
    if (!v.src) { var btn = wrap.querySelector('.hp-cv__btn'); if (btn) btn.classList.add('hp-cv__btn--static'); }
    box.appendChild(wrap);

    if (canHover && !reduceMotion) {
      if (v.src) attachHover(wrap, box, v.src, v.embedSrc);
      else if (v.embedSrc) attachHoverFrame(wrap, box, v.embedSrc);
    }
  }

  /* ========== ריחוף — <video> ========== */
  function attachHover(wrap, target, src, embedSrc) {
    var vid = wrap.querySelector('.hp-cv__video');
    var bar = wrap.querySelector('.hp-cv__progress');
    var loaded = false, timer, dead = false;

    function enter() {
      if (!loaded) { vid.src = src; vid.load(); loaded = true; }
      clearTimeout(timer);
      wrap.classList.add('is-playing');
      if (!CFG.SCRUB) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
    }
    function leave() {
      wrap.classList.remove('is-playing');
      timer = setTimeout(function () {
        vid.pause(); vid.currentTime = 0;
        if (bar) bar.style.width = '0%';
      }, 350);
    }
    function move(e) {
      if (!CFG.SCRUB || !vid.duration) return;
      var r = target.getBoundingClientRect();
      var ratio = (e.clientX - r.left) / r.width;
      if (getComputedStyle(document.documentElement).direction === 'rtl') ratio = 1 - ratio;
      ratio = Math.min(Math.max(ratio, 0), 1);
      vid.currentTime = vid.duration * ratio;
      if (bar) bar.style.width = ratio * 100 + '%';
    }

    vid.addEventListener('timeupdate', function () {
      if (CFG.SCRUB || !bar || !vid.duration) return;
      bar.style.width = (vid.currentTime / vid.duration) * 100 + '%';
    });

    /* אם ה-src הישיר לא ניתן לניגון (טיפוסי לקבצי Drive גדולים) —
       מפרקים את מסלול ה-<video> ועוברים למסלול ה-iframe.
       לסרטוני R2 אין embedSrc בכלל, אז זה פשוט לא יקרה עבורם. */
    vid.addEventListener('error', function () {
      if (dead) return;
      dead = true;
      log('⚠ src ישיר נכשל, עובר ל-iframe');

      target.removeEventListener('pointerenter', enter);
      target.removeEventListener('pointerleave', leave);
      target.removeEventListener('pointermove', move);
      target.removeEventListener('focusin', enter);
      target.removeEventListener('focusout', leave);

      clearTimeout(timer);
      wrap.classList.remove('is-playing');
      vid.remove();
      if (bar) { bar.remove(); bar = null; }

      if (embedSrc) attachHoverFrame(wrap, target, embedSrc, true);
    });

    target.addEventListener('pointerenter', enter);
    target.addEventListener('pointerleave', leave);
    target.addEventListener('pointermove', move);
    target.addEventListener('focusin', enter);
    target.addEventListener('focusout', leave);
  }

  /* ========== ריחוף — iframe (סרטון מזוהה דרך התיאור, Drive בלבד) ==========
     אותה לוגיקה של attachHover: טעינה עצלה בכניסה, is-playing מעלה את
     ה-opacity, ניקוי ביציאה. בלי scrub ובלי פס התקדמות — ל-iframe
     אין currentTime/duration נגישים.                                   */
  function attachHoverFrame(wrap, target, embedSrc, checkHoverNow) {
    var clip = null, timer;
    var base = embedSrc.split('#')[0];
    var url = base + (base.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1&mute=1';

    function enter() {
      clearTimeout(timer);
      if (!clip) {
        clip = document.createElement('div');
        clip.className = 'hp-cv__frame-clip';

        var frame = document.createElement('iframe');
        frame.className = 'hp-cv__frame';
        frame.setAttribute('allow', 'autoplay');
        frame.setAttribute('scrolling', 'no');
        frame.setAttribute('tabindex', '-1');
        frame.setAttribute('aria-hidden', 'true');
        frame.src = url;

        clip.appendChild(frame);
        wrap.insertBefore(clip, wrap.firstChild);
      }
      wrap.classList.add('is-playing');
    }
    function leave() {
      wrap.classList.remove('is-playing');
      timer = setTimeout(function () {
        if (clip) { clip.remove(); clip = null; }
      }, 600);
    }

    target.addEventListener('pointerenter', enter);
    target.addEventListener('pointerleave', leave);
    target.addEventListener('focusin', enter);
    target.addEventListener('focusout', leave);

    /* אם עברנו לכאן בזמן שהעכבר כבר עומד על הכרטיס — להתחיל מיד,
       אחרת לא יקרה כלום עד שהמשתמש ייצא וייכנס שוב */
    if (checkHoverNow) {
      try { if (target.matches(':hover')) enter(); } catch (e) {}
    }
  }

  /* ========== עיבוד קישור ========== */
  function processLink(link) {
    if (link.hasAttribute('data-hpcv')) return;
    link.setAttribute('data-hpcv', '1');

    var href = link.getAttribute('href') || '';
    var m = href.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    var handle = m[1];

    var box = findBox(link);
    if (!box) { log('אין תמונה:', decodeURIComponent(handle)); return; }
    if (box.querySelector('.hp-cv')) return;

    var boxKey = handle + '|' + (box.dataset.hpcvKey || (box.dataset.hpcvKey = Math.random()));
    if (done[boxKey]) return;
    done[boxKey] = 1;

    getProduct(handle).then(function (p) {
      if (!p.video) { log('⬜ אין וידאו:', decodeURIComponent(handle)); return; }
      if (box.querySelector('.hp-cv')) return;
      buildLayer(box, p, (link.textContent || '').trim().slice(0, 60));
      log('✅ נוסף:', decodeURIComponent(handle), p.video.id === 'desc' ? '(מהתיאור - Drive)' : p.video.id === 'r2' ? '(מהתיאור - R2)' : '(ממדיה)');
    }).catch(function (e) { log('❌', decodeURIComponent(handle), e.message); });
  }

  /* ========== סריקה ========== */
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { io.unobserve(e.target); processLink(e.target); }
        });
      }, { rootMargin: CFG.PRELOAD_MARGIN })
    : null;

  function scan() {
    var links = document.querySelectorAll('a[href*="/products/"]:not([data-hpcv-seen])');
    var n = 0;
    links.forEach(function (link) {
      link.setAttribute('data-hpcv-seen', '1');
      n++;
      if (io) io.observe(link); else processLink(link);
    });
    if (n) log('נסרקו', n, 'קישורי מוצר');
  }

  /* ========== כניסה ישירה לסרטון בעמוד המוצר ==========
     חשוב: אסור ללחוץ על כפתור כללי בתוך הסלייד — הכפתור הראשון בסדר ה-DOM
     הוא .product__media-zoom-lightbox שפותח את המודאל של Dawn (כל המדיה,
     בלי כפתור חזרה). לוחצים אך ורק על .deferred-media__poster.            */
  function findVideoSlide(id) {
    if (id) {
      var byId = document.querySelector('[data-media-id$="-' + id + '"]');
      if (byId) return byId;
    }
    var explicit = document.querySelector('.product__media-item--video, .product__media-item--external_video');
    if (explicit) return explicit;
    var dm = document.querySelector('.product__media-item deferred-media');
    return dm ? dm.closest('.product__media-item') : null;
  }

  function playSlideVideo(slide, attempt) {
    var v = slide.querySelector('video');
    if (!v) {
      if ((attempt || 0) < 12) setTimeout(function () { playSlideVideo(slide, (attempt || 0) + 1); }, 300);
      return;
    }
    v.setAttribute('playsinline', '');
    var p = v.play();
    if (p && p.catch) {
      p.catch(function () {
        v.muted = true;                       /* דפדפנים חוסמים ניגון עם סאונד בלי מגע */
        var p2 = v.play();
        if (p2 && p2.catch) p2.catch(function () {});
      });
    }
  }

  function clearHpMedia() {
    try {
      var u = new URL(location.href);
      u.searchParams.delete('hpmedia');
      history.replaceState(null, '', u.pathname + u.search);
    } catch (e) {}
  }

  function openProductVideo() {
    var id = new URLSearchParams(location.search).get('hpmedia');
    if (!id && location.hash !== '#hp-video') return;

    /* סרטון R2 — גוללים לתגית ה-<video data-hp-video> שכבר קיימת בתיאור,
       ומפעילים אותה (מוצג עם controls, אז זה פשוט play רגיל). */
    if (id === 'r2') {
      var rv = document.querySelector('video[data-hp-video]');
      if (rv) {
        try { rv.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { rv.scrollIntoView(); }
        rv.classList.add('hp-cv-target');
        var p = rv.play();
        if (p && p.catch) p.catch(function () {});
        clearHpMedia();
      }
      return;
    }

    /* סרטון מהתיאור (Drive) — גוללים ל-iframe שכבר קיים בעמוד */
    if (id === 'desc') {
      var f = document.querySelector('iframe[src*="drive.google.com"]');
      if (f) {
        try { f.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { f.scrollIntoView(); }
        f.classList.add('hp-cv-target');
        clearHpMedia();
      }
      return;
    }

    var tries = 0;
    var t = setInterval(function () {
      tries++;
      var slide = findVideoSlide(id);
      if (!slide) { if (tries > 24) clearInterval(t); return; }
      clearInterval(t);

      slide.classList.add('hp-cv-target');

      /* 1. מעבר של הגלריה לסלייד — לוחצים על ה-<button> שבתוך ה-<li>, לא על ה-<li> */
      var mid = slide.getAttribute('data-media-id');
      var thumb = mid && document.querySelector('[data-target="' + mid + '"]');
      var thumbBtn = thumb && thumb.querySelector('button, a');
      if (thumbBtn) thumbBtn.click();

      /* 2. גלילה + טעינת הסרטון — בלי לגעת בכפתור הלייטבוקס */
      setTimeout(function () {
        try { slide.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { slide.scrollIntoView(); }
        var poster = slide.querySelector('.deferred-media__poster');
        if (poster) poster.click();
        setTimeout(function () { playSlideVideo(slide, 0); }, 400);
      }, 300);

      /* 3. ניקוי ה-URL כדי שרענון או חזרה אחורה לא יפעילו את זה שוב */
      clearHpMedia();
    }, 250);
  }

  function init() {
    injectCSS();
    scan();
    openProductVideo();
    new MutationObserver(function () { scan(); }).observe(document.body, { childList: true, subtree: true });
    log('פעיל');
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();